import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Bonus = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 50px;
    border-bottom: 1px solid ${COLORS.grey};
    @media(min-width: 1180px) {
        flex-direction: row-reverse;
        justify-content: space-between;
    }
`;

export const Picture = styled.picture`
    margin-top: 35px;
    align-self: center;
    @media(max-width: 390px) {
        width: 100%;
        padding-right: 20px;
    }
`;

export const Img = styled(LazyLoadImage)`
    margin-top: 35px;
    max-width: 350px;
    align-self: center;
    @media(max-width: 390px) {
        width: 100%;
    }
`;

export const Source = styled.source`
    margin-top: 35px;
    max-width: 350px;
    align-self: center;
    @media(max-width: 390px) {
        width: 100%;
    }
`;

export const WrapperText = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media(min-width: 1180px) {
        width: 550px;
    }
`;

export const Title = styled.h2`
    margin-top: 0;
    margin-top: 50px;
    margin-bottom: 25px;
    ${FONTS.XXL};
    color: ${COLORS.black};
`;

export const Text = styled.p`
    margin: 0;
    margin-bottom: 20px;
    ${FONTS.S};
    color: ${COLORS.darkGrey};
`;

export const WrapperMobileBtn = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 305px;
    max-width: 100%;
    @media(min-width: 380px) {
        justify-content: space-between;
    }
`;
